import * as z from './base';
export class ZodLiteral extends z.ZodType {
    constructor() {
        // opt optional: () => ZodUnion<[this, ZodUndefined]> = () => ZodUnion.create([this, ZodUndefined.create()]);
        super(...arguments);
        // null nullable: () => ZodUnion<[this, ZodNull]> = () => ZodUnion.create([this, ZodNull.create()]);
        this.toJSON = () => this._def;
    }
}
ZodLiteral.create = (value) => {
    return new ZodLiteral({
        t: z.ZodTypes.literal,
        value: value,
    });
};
